const state = {
  agreedToCostIncrease: false,
  skusToUpgrade: [],
};

export { state };
